(() => {
  if (!document.documentElement.classList.contains('ks-mace-hero-preview')) return;
  const init = () => {
    const root = document.getElementById('KsGearBuy-ks-gear-mace');
    if (!root || root.dataset.heroConceptReady) return;
    root.dataset.heroConceptReady = 'true';
    document.querySelectorAll('template[data-mh-variant]').forEach(template => {
      const button = root.querySelector('[data-ks-variant="' + template.dataset.mhVariant + '"]');
      if (button) button.prepend(template.content.cloneNode(true));
    });
    const paths = ['<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>','<path d="M5 6v12M19 6v12M8 4v16M16 4v16M8 12h8"/>','<path d="M12 5v15M12 5C9 3 5 3 3 4v14c3-1 6-1 9 2 3-3 6-3 9-2V4c-2-1-6-1-9 1Z"/>'];
    root.querySelectorAll('.ks-pdp-benefits svg').forEach((icon,index) => {
      if (paths[index]) icon.innerHTML = paths[index];
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
